import styled from 'styled-components';

export const Wrapper = styled.div`
	height: 100%;
	padding: 2px;
`;
